export const COUNTRY_CODES = {
  spain: 'ES',
  italy: 'IT',
  portugal: 'PT',
  germany: 'DE',
  uae: 'AE',
  netherlands: 'NL',
  austria: 'AT',
  uk: 'GB',
  france: 'FR',
  belgium: 'BE',
  hungary: 'HU',
  czech: 'CZ',
  colombia: 'CO',
  thailand: 'TH',
  romania: 'RO',
  greece: 'GR',
  slovenia: 'SI',
  croatia: 'HR',
  usa: 'US',
  canada: 'CA',
  sweden: 'SE',
};
